import { isToday, isPast } from 'date-fns'



export const calculateState = (start, end) => {
  let state = 'pending';
  
  if(isToday(start) || isPast(start)) {
    state = 'open'
  }
  if(isPast(end)) {
    state = 'closed'
  }

  return state;
}